import { atom } from 'recoil';

const mapTypeState = atom({
    key: 'mapType',
    default: undefined
});

export default mapTypeState;